<template>
    <div class="com-part1">
        <MyTitle title="能源监测" subTitle="PUE" />
        <div class="pue-list flex align-center mt-100">
            <div
                v-for="(item, i) in pueList" :key="'pueList' + i"
                class="flex1 pue-item flex flex-direction align-center">
                <p class="label">{{ item.label }}</p>
                <p class="value mt-10">{{ item.value }}</p>
                <p class="unit">{{ item.unit }}</p>
            </div>
        </div>
        <!-- 原设计图 -->
        <!-- <MyTitle class="mt-20" type="2" title="实时IT负载" /> -->
        <!-- <div class="p-content flex align-center">
            <myEchart
                v-if="showBatteryCharging"
                :id="'showBatteryCharging'"
                :options="batteryChargingData" />
        </div> -->
    </div>
</template>

<script>
import MyTitle from '../myTitle.vue'
// import myEchart from "./charts/echarts"
import { dataInterface } from "@/api/dataInterfaceApi"
import { formatTime } from '@/utils/index'
export default {
    components: {
        MyTitle,
        // myEchart
    },
    data() {
        return {
            pueList: [
                {
                    label: '总能耗',
                    value: '590',
                    unit: 'kW'
                },
                {
                    label: 'IT能耗',
                    value: '590',
                    unit: 'kW'
                },
                {
                    label: 'PUE',
                    value: '590',
                    unit: 'kW'
                }
            ],
            // 充电参数实时检测
            showBatteryCharging: false,
            batteryChargingData: {}
        }
    },
	mounted() {
        // 充电参数实时检测
        this.getbatteryCharging()
    },
	methods: {
        // 充电参数实时检测
        getbatteryCharging() {
          let params = { 
            enCode: 'TiDB-dianchidianyadianliuwenduliebiao',
            '@bn': this.batteryId || '08IPBN80032A3AC190200013',
          }
          dataInterface.dataFaceApi(params).then(res => {
            console.log(res, '充电参数实时检测')
            let xAxisData = []
            let data1 = []
            let data2 = []
            let data3 = []
            let data4 = []
            let data5 = []
            let data6 = []
            res.forEach(item => {
              xAxisData.push(formatTime(item.ts, 'HH:ss'))
              // data1 充电机电流
              data1.push(item.chgOutputCurr)
              // data2 充电机电压
              data2.push(item.currTotalInterVoltV1)
              // data3 电池最高电压
              data3.push(item.batMaxVolt)
              // data4 电池最低电压
              data4.push(item.batMinVolt)
              // data5 最高温度
              data5.push(item.batMaxTemp)
              // data6 最低温度
              data6.push(item.batMinTemp)
            })
            this.batteryChargingData = {
              tooltip: {
                trigger: 'axis'
              },
              legend: {
                data: ['充电机电流', '充电机电压', '电池最高电压', '电池最低电压', '最高温度', '最低温度']
              },
              xAxis: {
                type: 'category',
                // data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
                data: xAxisData
              },
              
              yAxis: [{
                  type: 'value',
                  name:'电压(V)'
                },{
                  type: 'value',
                  name: '电流(A)'
                }],
              series: [
                {
                  name: '充电机电流',
                  // data: [150, 230, 224, 218, 135, 147, 260],
                  data: data1,
                  type: 'line',
                  lineStyle: {
                    color: '#62F4CA',
                  },
                  yAxisIndex: 1,
                },
                {
                  name: '充电机电压',
                  // data: [250, 130, 229, 418, 435, 847, 560],
                  data: data2,
                  lineStyle: {
                    color: '#1A6AFF',
                  },
                  type: 'line'
                },
                {
                  name: '电池最高电压',
                  // data: [950, 230, 302, 218, 135, 147, 260],
                  data: data3,
                  lineStyle: {
                    color: '#9256AD',
                  },
                  type: 'line'
                },
                {
                  name: '电池最低电压',
                  // data: [200, 130, 229, 1018, 135, 847, 560],
                  data: data4,
                  lineStyle: {
                    color: '#5B8FF9',
                  },
                  type: 'line'
                },
                {
                  name: '最高温度',
                  // data: [150, 230, 224, 2018, 135, 1547, 260],
                  data: data5,
                  lineStyle: {
                    color: '#93E59A',
                  },
                  type: 'line'
                },
                {
                  name: '最低温度',
                  // data: [250, 130, 229, 1418, 2435, 1837, 560],
                  data: data6,
                  lineStyle: {
                    color: '#46FFF5',
                  },
                  type: 'line'
                }
              ]
            }
            this.showBatteryCharging = true
          })
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../comm.scss';
.com-part1 {
    width: 100%;
    height: 486px;
    .pue-list {
        height: 216px;
        .pue-item {
            height: 100%;
            background: url(~@/assets/images/computility/dispatch-icon5.png) center no-repeat;
            background-size: 220px 216px;
            animation: breath_light 3s ease infinite;
            > p {
                display: flex;
                // align-items: center;
                justify-content: center;
                font-size: $FontSize24;
            }
            .label {
                height: 38px;
                font-size: $FontSize36;
            }
            .value {
                font-family: 'DS-Digital-Bold';
                font-size: $FontSize30;
            }
        }
    }
    .p-content {
        width: 100%;
        height: 320px;
    }
}
</style>